export default "__VITE_ASSET__60bba8a0__"